import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const d = {
  display: "block"
}, f = ({ size: e = 16, useVw: l, useRem: i, color: n, withColor: o, removeClassName: t, disableSSR: m, style: c, ...p }) => {
  const v = c ? { ...d, ...c } : d;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-jiaoyijiqiren", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (i ? "rem" : "px"), height: l ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (i ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: v, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "24px-äº¤ææºå¨äºº"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: o ? r(n, 0, "#262933") : "#262933",
        datafollowfill: o ? r(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M12 1.7a.8.8 0 0 1 .8.8v1.92a3.73 3.73 0 0 1 1.063.413l4.387 2.533a3.725 3.725 0 0 1 1.863 3.226v5.066c0 1.33-.71 2.56-1.863 3.226l-4.387 2.533a3.725 3.725 0 0 1-3.726 0L5.75 18.884a3.725 3.725 0 0 1-1.863-3.226v-5.066c0-1.331.71-2.56 1.863-3.226l.366-.211a.8.8 0 0 1 .8 1.385l-.366.211a2.125 2.125 0 0 0-1.063 1.84v5.067c0 .76.405 1.46 1.063 1.84l4.388 2.533c.657.38 1.467.38 2.124 0l4.388-2.533a2.125 2.125 0 0 0 1.063-1.84v-5.066c0-.76-.406-1.461-1.063-1.84l-4.387-2.534a2.125 2.125 0 0 0-2.126 0l-1.28.739a.8.8 0 0 1-.8-1.386l1.28-.738A3.72 3.72 0 0 1 11.2 4.42V2.5a.8.8 0 0 1 .8-.8Zm-9.75 8.593a.8.8 0 0 1 .8.8v4.063a.8.8 0 0 1-1.6 0v-4.063a.8.8 0 0 1 .8-.8Zm20.3.801a.8.8 0 1 0-1.6 0v4.062a.8.8 0 1 0 1.6 0v-4.063Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M6.719 12.312a2.437 2.437 0 0 1 2.437-2.437h5.688a2.437 2.437 0 1 1 0 4.874H9.156a2.437 2.437 0 0 1-2.437-2.437Zm2.437-.837h5.688a.838.838 0 0 1 0 1.675H9.156a.837.837 0 1 1 0-1.675Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, s = f;
export {
  s as default
};
